import * as Types from '../actions/Types'

const INITIAL_STATE = {
  isCreating: false,
  errorCreating: null,
  isUpdating: false,
  errorUpdating: null,
  selected: null
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action

  switch (type) {
    case Types.CREATE_BOOKING_SYSTEM_TIME:
      return {
        ...state,
        isCreating: true,
        errorCreating: null
      }
    case Types.CREATE_BOOKING_SYSTEM_TIME_SUCCESS:
      return {
        ...state,
        isCreating: false,
        errorCreating: null
      }
    case Types.CREATE_BOOKING_SYSTEM_TIME_FAILED:
      return {
        ...state,
        isCreating: false,
        errorCreating: payload
      }
    case Types.UPDATE_BOOKING_SYSTEM_TIME:
      return {
        ...state,
        isUpdating: true,
        errorUpdating: null
      }
    case Types.UPDATE_BOOKING_SYSTEM_TIME_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: null
      }
    case Types.UPDATE_BOOKING_SYSTEM_TIME_FAILED:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: payload
      }
    // NOTE: Selected contains a time object and a booking system id.
    case Types.SHOW_EDIT_BOOKING_SYSTEM_TIME_MODAL:
      return {
        ...state,
        selected: payload
      }
    // NOTE: Selected contains a booking system id.
    case Types.SHOW_CREATE_BOOKING_SYSTEM_TIME_MODAL:
      return {
        ...state,
        selected: payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/reducers/BookingSystemTimes.js